import { cn } from "@garther/ui/libs";

interface SelectableCardProps {
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  className?: string;
}

export function SelectableCard({
  isSelected = false,
  isDisabled,
  onClick,
  children,
  className,
}: SelectableCardProps) {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        "border rounded-sm text-left transition-colors cursor-pointer",
        isSelected
          ? "border-border-dark bg-background-highlight"
          : "border-border-light hover:bg-background-highlight",
        isDisabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      {children}
    </button>
  );
}
